/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "gray.100");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "gray.400"
  );
  let activeIcon = useColorModeValue("white", "dark.900");
  let textColor = useColorModeValue("secondaryGray.500", "gray.300");
  let activeBg = useColorModeValue("rgba(0, 106, 184, 1)", "aqua.300");
  let activeTextColor = useColorModeValue("white", "dark.900");
  let hoverBg = useColorModeValue("rgba(0, 106, 184, 0.08)", "whiteAlpha.100");

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <>
            <Text
              fontSize="18px"
              color={activeColor}
              fontWeight='bold'
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt='18px'
              pb='12px'
              key={index}>
              {route.name}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (
        route.layout === "/admin" 
      ) {
        const isActive = activeRoute(route.path.toLowerCase());

        return (
          <NavLink
            key={index}
            to={route.layout + route.path}
            style={{ display: "block", textDecoration: "none" }}>
            {route.icon ? (
              <Box w='100%' mb='6px'>
                <HStack
                  w='100%'
                  spacing='0'
                  minH='48px'
                  px='14px'
                  py='5px'
                  bg={isActive ? activeBg : "transparent"}
                  _hover={{ bg: isActive ? activeBg : hoverBg }}
                  borderRadius='8px'>
                  <Flex w='100%' alignItems='center' justifyContent='center'>
                    <Box
                      color={isActive ? activeIcon : textColor}
                      me='18px'>
                      {route.icon}
                    </Box>
                    <Text
                      me='auto'
                      fontSize='18px'
                      color={isActive ? activeTextColor : textColor}
                      fontWeight={isActive ? "bold" : "normal"}>
                      {route.name}
                    </Text>
                  </Flex>
                </HStack>
              </Box>
            ) : (
              <Box w='100%' mb='6px'>
                <HStack
                  w='100%'
                  spacing='0'
                  minH='48px'
                  px='14px'
                  py='5px'
                  bg={isActive ? activeBg : "transparent"}
                  _hover={{ bg: isActive ? activeBg : hoverBg }}
                  borderRadius='8px'>
                  <Text
                    me='auto'
                    fontSize='18px'
                    color={isActive ? activeTextColor : inactiveColor}
                    fontWeight={isActive ? "bold" : "normal"}>
                    {route.name}
                  </Text>
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
